import {createAction} from '@reduxjs/toolkit';

import type {ReleaseNoteInfo} from 'src/openapi/admin/models/ReleaseNoteInfo';

export const setReleaseNotes = createAction<ReleaseNoteInfo>('SET_RELEASE_NOTES');
export const clearError = createAction('CLEAR_RELEASE_NOTES_ERROR');
